module.exports = "img/icon-context-mute-off-copy.8b8d189.svg";